import * as React from 'react';

import { translate } from '~l10n/client';
import { toast } from '~shared/components/Toast';

import { InsightsNone } from './InsightsNone';

interface InsightsInsufficientDataProps {
  activityInstanceId: number;
  showPaywall: boolean;
  setShowPaywall: (show: boolean) => void;
  averageScoreRate?: number | null;
}

export function InsightsInsufficientData({
  activityInstanceId,
  showPaywall,
  setShowPaywall,
  averageScoreRate,
}: InsightsInsufficientDataProps) {
  React.useEffect(() => {
    toast.critical(translate('Insufficient data to display insights'));
  }, []);

  return (
    <InsightsNone 
      activityInstanceId={activityInstanceId}
      showPaywall={showPaywall}
      setShowPaywall={setShowPaywall}
      averageScoreRate={averageScoreRate}
    />
  );
}
